import { Table } from 'components'
import moment from 'locale/momentLocale'
import React from 'react'
import { useTranslation } from 'react-i18next'
import type { StoreResult } from 'types/StoreResult'
import { currencyToShort, emptyArray } from 'utils'

import { Conversion, Date, Revenue, Traffic, Weather } from './cellComponents'

interface Props {
  results: StoreResult[]
}

function ResultTab({ results = emptyArray }: Props) {
  const { t: translate } = useTranslation()
  const selected = [results.findIndex(result => moment().isSame(moment(result.date), 'day'))]
  const conversionMax = Math.max(...results.map(item => item.conversionCurrent))
  const revenueMax = Math.max(...results.map(item => item.revenueCurrent))
  const trafficMax = Math.max(...results.map(item => item.trafficCurrent))
  const currency = (results[0] && ` [${currencyToShort(results[0].currency)}]`) || ''
  const textDayToDay = translate('revenue.details.result.dayToDay')
  const columns = [
    {
      key: 'date',
      title: translate('revenue.details.result.date'),
      CellRender: Date,
    },
    {
      key: 'traffic',
      title: translate('revenue.details.result.traffic'),
      subtitle: textDayToDay,
      CellRender: Traffic,
    },
    {
      key: 'conversion',
      title: translate('revenue.details.result.conversion'),
      subtitle: textDayToDay,
      CellRender: Conversion,
    },
    {
      key: 'sale',
      title: `${translate('revenue.details.result.sale')}${currency}`,
      subtitle: textDayToDay,
      CellRender: Revenue,
    },
    {
      key: 'weather',
      title: translate('revenue.details.result.weather'),
      subtitle: textDayToDay,
      CellRender: Weather,
    },
  ]

  return (
    <Table
      columns={columns}
      data={results.map(result => ({
        ...result,
        conversionMax,
        revenueMax,
        trafficMax,
      }))}
      selected={selected}
      tableClassName="details-result-table"
    />
  )
}

export default ResultTab
